module.exports = __webpack_public_path__ + "static/media/icon_localization.4833f298.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_localization.svg
// module id = 330
// module chunks = 0